import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">

        <div className="footer-brand">
          <Link to="/" className="footer-logo">
            <img src="/favicon.ico?v=2" alt="CrousRadar" />
            <span>CrousRadar</span>
          </Link>
          <p className="footer-tagline">
            L'application communautaire pour optimiser tes repas au RU.
          </p>
          <div className="footer-socials">
            <a href="https://www.instagram.com/crousradar/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
            </a>
            <a href="https://www.tiktok.com/@crousradar" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1 0-5.78c.27 0 .54.04.79.1v-3.5a6.37 6.37 0 0 0-.79-.05A6.34 6.34 0 0 0 3.15 15.2a6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.71a8.24 8.24 0 0 0 3.76.92V6.18a4.83 4.83 0 0 1 0 .51z"/></svg>
            </a>
            <a href="https://www.linkedin.com/company/crous-radar/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>
            </a>
          </div>
        </div>

        <div className="footer-links-grid">
          <div className="footer-col">
            <h4>Application</h4>
            <a href="https://apps.apple.com/fr/app/crousradar/id6755202143" target="_blank" rel="noopener noreferrer">iOS App Store</a>
            <a href="#">Google Play (Bientôt)</a>
          </div>

          <div className="footer-col">
            <h4>À propos</h4>
            <Link to="/about">Qui sommes-nous</Link>
            <Link to="/join">Nous rejoindre</Link>
            <Link to="/impact">Notre impact</Link>
            <Link to="/blog">Actu</Link>
            <Link to="/etablissement">Espace Établissement</Link>
          </div>

          <div className="footer-col">
            <h4>Support & Légal</h4>
            <a href="mailto:contact@crousradar.fr">Nous contacter</a>
            <Link to="/legal">Mentions légales</Link>
            <Link to="/privacy">Politique de confidentialité</Link>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {currentYear} CrousRadar. Créé avec ❤️ en France.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;